import { render, staticRenderFns } from "./legendBox5.vue?vue&type=template&id=4144ce72&scoped=true&"
import script from "./legendBox5.vue?vue&type=script&lang=js&"
export * from "./legendBox5.vue?vue&type=script&lang=js&"
import style0 from "./legendBox5.vue?vue&type=style&index=0&id=4144ce72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4144ce72",
  null
  
)

export default component.exports